import type { PropsWithChildren } from 'react';

import type { TypographyVariant } from 'src/app/components/Elements/Typography';
import { Typography } from 'src/app/components/Elements/Typography';

import {
  OutlinedVariant,
  RefillRequestedToastVariant,
  ToggleArchiveToastVariant,
  TrailingTransparentGradient,
  ViewOrderToastVariant,
} from './styles';

const ToastBannerVariants = {
  refillRequested: RefillRequestedToastVariant,
  viewOrder: ViewOrderToastVariant,
  toggleArchive: ToggleArchiveToastVariant,
  outlined: OutlinedVariant,
};

interface ToastBannerProps
  extends PropsWithChildren<{
    variant: 'outlined' | 'viewOrder' | 'toggleArchive' | 'refillRequested';
    text: string;
    textVariant: TypographyVariant;
    medicationsHomepageHack: boolean;
    showTrailingTransparentGradient?: boolean;
    onClick?: () => void;
  }> {}

export const ToastBanner = ({
  children,
  text,
  textVariant,
  variant,
  medicationsHomepageHack,
  showTrailingTransparentGradient = true,
  onClick = undefined,
}: ToastBannerProps) => {
  const ToastBannerComponent = ToastBannerVariants[variant];
  return (
    <>
      <ToastBannerComponent
        onClick={() => {
          if (onClick !== undefined) onClick();
        }}
        medicationsHomepageHack={medicationsHomepageHack}
      >
        <Typography variant={textVariant} color={variant === 'outlined' ? 'capsuleBlue50' : 'white'}>
          {text}
        </Typography>
        {children}
      </ToastBannerComponent>
      {showTrailingTransparentGradient && <TrailingTransparentGradient />}
    </>
  );
};
